<template>
  <div class="cta-wrapper d-flex align-items-center justify-content-center mx-auto mx-md-n3 mx-lg-auto my-4 text-muted">
    <div class="d-flex align-items-center position-relative">
      <div class="image-wrapper image-wrapper-1 d-flex align-items-end justify-content-end rounded pl-1" style="background-image: url('/images/canva-cta/bg_pre_1.jpg')">
        <img :src="image" class="img-fluid" />
      </div>
      <div class="image-wrapper image-wrapper-2 d-flex align-items-end justify-content-end rounded pl-1" style="background-image: url('/images/canva-cta/bg_pre_2.jpg')">
        <img :src="image" class="img-fluid" />
      </div>
      <div class="image-wrapper image-wrapper-3 d-flex align-items-end justify-content-end rounded pl-1" style="background-image: url('/images/canva-cta/bg_pre_3.jpg')">
        <img :src="image" class="img-fluid" />
      </div>
    </div>
    <a :href="url" @click="report" class="small text-decoration-none pl-2 text-left text-muted d-inline-block" target="_blank" rel="noopener noreferer">
      Turn it into <br>a design
      <i class="pl-1 fas fa-external-link" />
    </a>
  </div>
</template>

<script>
export default {
  props: {
    image: String,
    variant: String,
  },

  computed: {
    url() {
      const campaign = `en_all_canva_acq_conversion_kaleido_variant_preDownload`
      const url = new URL("https://canva.com")

      url.searchParams.append("utm_medium", "referral")
      url.searchParams.append("utm_source", "removebg")
      url.searchParams.append("utm_campaign", campaign)

      return url.href
    }
   },

   methods: {
     report() {
       reportSplit("canva_cta_conversion", null, false)
     }
   }
}
</script>

<style lang="scss" scoped>

.cta-wrapper {
  max-width: 220px;
  flex-basis: 100%;
}

.image-wrapper {
  overflow: hidden;
  border: 0.5px solid white;
  background-position: center;
  background-size: cover;

  &.image-wrapper-1 {
    width: 47px;
    height: 47px;
    z-index: 3;

    img {
      max-height: 47px;
    }
  }

  &.image-wrapper-2 {
    width: 43px;
    height: 43px;
    margin-left: -29.5px;
    z-index: 2;

    img {
      max-height: 43px;
    }
  }

  &.image-wrapper-3 {
    width: 39px;
    height: 39px;
    margin-left: -28px;
    z-index: 1;

    img {
      max-height: 39px;
    }
  }

  img {
    display: block;
    object-fit: contain;
  }
}
</style>
